import { isOidcCallbackHash, stripAutoLoginParam } from '@/plugins/autoLogin.js';

export const authenticationMixin = {
  data () {
    return {
      profileOpen: false,
      loggedIn: false,
      user: null
    }
  },
  methods: {
    authenticationLogin (returnPath) {
      try {
        let route = returnPath || (this.$router && this.$router.currentRoute
          ? this.$router.currentRoute.fullPath
          : `${window.location.pathname}${window.location.search}`);
        sessionStorage.setItem('reff', stripAutoLoginParam(route) || '/');
      } catch (e) {
        // ignore storage errors
      }
      return this.$authenticator.signIn();
    },
    authenticationLogout () {
      delete this.axios.defaults.headers.common['Authorization'];

      let manager = this.$authenticator.getManager();
      this.clearCustomerCache().catch(() => null).then(() => {
        return manager.removeUser().catch(() => null);
      }).then(() => {
        this.$authenticator.signOut();
      });
    },
    authenticationCheckCredentials () {

      // bad practice - mixins shouldn't change state; here due to legacy reasons
      let user = this.$authenticator.getUser();
     
      if (!user.isSignedIn) {
        //console.log(`isSignedIn: ${user.isSignedIn}`)
        return false;
      }

      if (typeof user.decodedPayload === 'undefined') {
        //console.log("cannot found decodedPayload");
        return false;
      } 
      
      let ressourceAccess = user.decodedPayload.resource_access['onsite-suite'];
      
      if (typeof ressourceAccess !== 'undefined') {
        let validScopeUserRoles = ['scope_customer', 'scope_staff'];
        let validUserRoles = ['admin', 'firstlevel', 'firstlevel_connector', 'zerolevel', 'tracyapp', 'secondlevel', 'projectmanager', 'moderation'];
        let validCredentials = ressourceAccess.roles.some(role => validUserRoles.includes(role)) && ressourceAccess.roles.some(role => validScopeUserRoles.includes(role));
        if (ressourceAccess.roles.includes("scope_staff") && !user.decodedPayload.email.includes('@alturos.com')) {
          this.authenticationLogout();
          return false;
        }
        if(!validCredentials) {
          this.authenticationLogout();
          return false;
        }

        if (user.decodedPayload.exp < (new Date().getTime() + 1) / 1000) {
          this.loggedIn = false;
          //console.log("token is expired");
          return false;
        }

        this.user = user;
        this.loggedIn = validCredentials;
        return true;
      }

      //console.log("ressourceAccess has wrong state");
      return false;
    },
    loadUserFromLocalStorage () {
      return this.$authenticator.loadUser().then((user) => {
        if (user === null || !user.access_token) {
          delete this.axios.defaults.headers.common['Authorization'];
          return null;
        }

        this.$authenticator.setUser(user);
        this.axios.defaults.headers.common['Authorization'] = `Bearer ${user.access_token}`;
        return user;
      });
    },
    authenticationIsRedirectFromIdentityService () {
      //also matches error callbacks (#error=...&state=...) so the hash gets cleaned up
      return isOidcCallbackHash(window.location.hash);
    },
    //true if a non-expired token is loaded, i.e. a failed credential check means missing permissions
    authenticationHasValidToken () {
      let user = this.$authenticator.getUser();
      return !!(user.isSignedIn && user.decodedPayload && user.decodedPayload.exp > Date.now() / 1000);
    },
    authenticationClearIdentityServiceCallback () {
      if (!window.location.hash) {
        return;
      }

      let params = new URLSearchParams(window.location.hash.substring(1));
      let oidcParams = ['state', 'session_state', 'iss', 'code', 'id_token', 'access_token', 'token_type', 'expires_in', 'scope', 'error', 'error_description'];
      let hasOidcPayload = oidcParams.some(param => params.has(param));
      if (!hasOidcPayload) {
        return;
      }

      let cleanUrl = `${window.location.origin}${window.location.pathname}${window.location.search}`;
      window.history.replaceState({}, document.title, cleanUrl);
    },
    checkIsRedirectFromIdentityService () {
      //check if the site is currently called as a callback and let the library parse the state
      if (!this.authenticationIsRedirectFromIdentityService()) {
        return Promise.resolve(false);
      }

      var manager = this.$authenticator.getManager()
      return manager.signinRedirectCallback().then((user) => {
        this.$authenticator.setUser(user);
        this.axios.defaults.headers.common['Authorization'] = `Bearer ${user.access_token}`;
        this.authenticationClearIdentityServiceCallback();
        return true;
      }).catch((err) => {
        // eslint-disable-next-line no-console
        console.error(`signinRedirectCallback: ${err}`);
        delete this.axios.defaults.headers.common['Authorization'];
        this.authenticationClearIdentityServiceCallback();
        return manager.removeUser().catch(() => null).then(() => false);
      });
    },
    authenticationGetUser () {
      return this.$authenticator.getUser();
    },
    authenticationHasRole (requiredRole) {
      if(this.$authenticator) {
        let user = this.$authenticator.getUser();
        let userRoles = user.decodedPayload.resource_access['onsite-suite'].roles;
        return userRoles.includes(requiredRole);
      }
      return false;
    },
    async clearCustomerCache () {
      await this.axios.get(`/installation/ClearCustomerInstallationCache`)
    }
  }
};
